import './Component_NoAlternate_Slots.css';
import Icons_Repository from '../Icons/Icons_Repository';
function Component_NoAlternate_Slots({setnoAlternateRescheduleSlots}:any){
    return (
        <div className="main-popup-container">
            <div className='no-alternate-slots-popup-card'>
                <div className='no-alternate-slots-popup-header'>
                    <div className='no-alternate-cancel-button-parent'>
                        <div 
                        onClick={() => {
                            // setShowReschedulePopup(false);
                            setnoAlternateRescheduleSlots(false);
                        }}
                        >
                            <Icons_Repository iconName='x' />
                        </div>
                    </div>
                </div>
                <div className='no-alternate-slots-section'>
                    <div className='no-alternate-slots-text-container'>
                        <div className='no-alternate-slots-text'>
                            No Interview Slots Available
                        </div>
                        <div className='no-alternate-slots-subtext'>
                            There are currently no available interview slots. Please check back later for updated availability or contact your recruiter for assistance.
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    )
}
export default Component_NoAlternate_Slots